export default "__VITE_ASSET__CSwtNa4o__"